import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { IGenericResponse } from '../../models/IGenericResponse';
import { Distribuidores } from 'src/app/models/Distribuidores';
@Injectable({
  providedIn: 'root'
})
export class GestionarDistribuidoresService {

  private http = inject(HttpClient);
  private url = environment.api;

  constructor() {}

  getDistribuidores() {
    return this.http.get<IGenericResponse>(this.url + "/gestionar-distribuidores/distribuidores"); 
  }
  editarDistribuidor(distribuidor: Distribuidores) {
    return this.http.put<IGenericResponse>(this.url + "/gestionar-distribuidores/distribuidores", distribuidor);
  }  
  crearDistribuidor(distribuidor: Distribuidores) {
    return this.http.post<IGenericResponse>(this.url + "/gestionar-distribuidores/distribuidores", distribuidor);
  }
}